'use client';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

// import {
//   checkoutPrereqMet, 
// } from '../../../../../utils/checkout';

import CheckoutStepPaymentDetailsInput from './CheckoutStepPaymentDetailsInput';

let allActionCreators = Object.assign({});

export class CheckoutStepPaymentDetails extends Component {

  getStepComponent() {

    const { checkoutPrereqMet } = require('../../../../../utils/checkout');

    // const { CheckoutStepPaymentDetailsInput } = require('./CheckoutStepPaymentDetailsInput').default;

    // If pre-requisites not met, do not display
    if(checkoutPrereqMet(this.props.config, this.props.checkout.stepData) === false) {
      return null;
    }

    return <CheckoutStepPaymentDetailsInput 
            config={this.props.config}
            setStepData={this.props.setStepData} />;
  }

  render() {
    return <div className={'CheckoutStepPaymentDetails'}>{this.getStepComponent()}</div>;
  }
}

function mapStateToProps(state) {
  return {
    checkout: state.checkout,
  };
}

export default connect(mapStateToProps, allActionCreators)(withTranslation()(CheckoutStepPaymentDetails));